import React from 'react';//, { Component } 

const className = (props) => {
    if (props.touched && props.error) { return 'form-group has-error' }
    else if (props.touched && props.warning) { return 'form-group has-warning' }
    return 'form-group';
}

export const Input = ({ input, label, type }) => {//, meta: { touched, error, warning } }) => {
    let inputTag = "";
    if (type === "title") {
        inputTag = <input {...input} type={type} className="form-control" ParentCallBack="updateSlug" />
    } else {
        inputTag = <input {...input} type={type} className="form-control" ParentCallBack="updateSlug" />
    }
    return (
        <div >
            <label>{label}</label>
            {inputTag}
            
        </div >
    )//{touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span className="text-warning">{warning}</span>))}className={className({touched,error,warning})}
}

export const FileInput = ({ input, label, allowMultiple, meta: { touched, error, warning } }) => {
    return (
        <div className={className({ touched, error, warning })}>
            <label>{label}</label>
            <div>
                <div className="file-wrapper">
                    <input {...input} type="file" className="form-control" allowMultiple={allowMultiple}/>
                    <button className="btn btn-info">Browse</button>
                </div>
            </div>
            {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span className="text-warning">{warning}</span>))}
        </div >
    )
}

export const PasswordInput = ({ input, label, allowMultiple, meta: { touched, error, warning } }) => {
    return (
        <div className={className({ touched, error, warning })}>
            <label>{label}</label>
            <div>
                <div className="file-wrapper">
                    <input {...input} type="password" className="form-control" allowMultiple={allowMultiple}/>
                    <button className="btn btn-info">Browse</button>
                </div>
            </div>
            {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span className="text-warning">{warning}</span>))}
        </div >
    )
}

export const TextArea = ({ input, label, meta: { touched, error, warning } }) => (
    <div className={className({ touched, error, warning })}>
        <label>{label}</label>
        <textarea {...input} className="form-control"/>
        {touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span className="text-warning">{warning}</span>))}
    </div >
)